<template>
  <div :class="$utilModalStyle.modalOverlay">
    <div :class="[$utilModalStyle.modalContent, $style.gameWinnerModalContent]" @click.stop>
      <div :class="$style.resultContent">
        <img
          :src="
            props.gameWinner === 'Saboteur'
              ? theaterImg
              : props.gameWinner === 'Players'
              ? teamImg
              : handshakeImg
          "
          :class="$style.resultImage"
        />
        <div :class="styles.resultTitle">
          {{
            props.gameWinner === "Saboteur"
              ? $t('saboteur-won')
              : props.gameWinner === "Players"
              ? $t('players-won')
              : props.gameWinner === "None"
              ? $t('game-tied')
              : $t('no-saboteur')
          }}
        </div>
        <div :class="$style.resultText">
          {{
            props.gameWinner === "Saboteur"
              ? $t('diverted-players')
              : props.gameWinner === "Players"
              ? $t('identified-text')
              : props.gameWinner === "None"
              ? $t('game-tied-description')
              : $t('no-saboteur-description')
          }}
        </div>
      </div>
      <div :class="$utilModalStyle.modalActions">
        <!-- <button :class="$utilModalStyle.secondaryAction" @click="closeModal">I'll Wait</button> -->
        <button :class="$utilModalStyle.primaryAction" @click="props.closeModal">{{ $t('close') }}</button>
      </div>
      <!-- <div :class="$utilModalStyle.modalHelperText">
        <span>Note:</span> If the timer runs out, the game will automatically proceed to the next
        phase!
      </div> -->
    </div>
  </div>
</template>

<script setup>
import styles from "@/css/GameWinnerModal.module.css";
import utilModalStyles from "@/css/UtilModal.module.css";
import TeamImg from "@/assets/team.png";
import TheaterImg from "@/assets/theater.png";
import HandshakeImg from "@/assets/handshake.png";
import confetti from "canvas-confetti";
import { onMounted } from "vue";

const $style = styles;
const $utilModalStyle = utilModalStyles;
const teamImg = TeamImg;
const theaterImg = TheaterImg;
const handshakeImg = HandshakeImg;

// eslint-disable-next-line
const props = defineProps({
  gameWinner: {
    type: String,
    required: true,
  },
  closeModal: {
    type: Function,
    required: true,
  },
});

onMounted(() => {
  if (props.gameWinner === "Saboteur") {
    // Saboteur win animation (dramatic burst)
    confetti({
      particleCount: 150,
      spread: 120,
      angle: 90,
      origin: { y: 0.6 },
      colors: ["#ff0000", "#000"],
    });
  } else if (props.gameWinner === "Players") {
    // Players win animation (cheerful, colorful)
    confetti({
      particleCount: 200,
      spread: 180,
      origin: { y: 0.6 },
      colors: ["#00e676", "#2979ff", "#fbc02d"],
    });
  } else {
    // Tied animation (subtle burst)
    confetti({
      particleCount: 50,
      spread: 100,
      origin: { y: 0.6 },
      colors: ["#999", "#ccc"],
    });
  }
});
</script>

<style scope></style>
